// src/services/parkingService.js
import apiClient from './apiClient';

const parkingService = {
  // Crear un nuevo parqueo
  createParking: async (parkingData) => {
    try {
      console.log('Sending parking data to backend:', JSON.stringify(parkingData, null, 2));
      const response = await apiClient.post('/parkings/createParking', parkingData);
      console.log('Response from backend:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error details:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener todos los parqueos
  getAllParkings: async () => {
    try {
      const response = await apiClient.get('/parkings/getAllParkings');
      return response.data;
    } catch (error) {
      console.error('Error al obtener parqueos:', error);
      throw error;
    }
  },

  // Obtener parqueo por ID
  getParkingById: async (parkingId) => {
    try {
      const response = await apiClient.get(`/parkings/getParkingById/${parkingId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener parqueo ${parkingId}:`, error);
      throw error;
    }
  },

  // Actualizar un parqueo existente
  updateParking: async (parkingId, parkingData) => {
    try {
      console.log('Updating parking data:', JSON.stringify(parkingData, null, 2));
      const response = await apiClient.put(`/parkings/updateParking/${parkingId}`, parkingData);
      console.log('Update response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar parqueo ${parkingId}:`, error);
      throw error;
    }
  },

  // Eliminar un parqueo
  deleteParking: async (parkingId) => {
    try {
      const response = await apiClient.delete(`/parkings/deleteParking/${parkingId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar parqueo ${parkingId}:`, error);
      throw error;
    }
  },

  // Agregar placa a la blacklist de un parqueo
  addToBlacklist: async (parkingId, plate) => {
    try {
      const response = await apiClient.post(`/parkings/${parkingId}/blacklist`, { plate });
      return response.data;
    } catch (error) {
      console.error(`Error al agregar placa ${plate} a blacklist del parqueo ${parkingId}:`, error);
      throw error;
    }
  },

  // Remover placa de la blacklist de un parqueo
  removeFromBlacklist: async (parkingId, plate) => {
    try {
      const response = await apiClient.delete(`/parkings/${parkingId}/blacklist`, {
        data: { plate }
      });
      return response.data;
    } catch (error) {
      console.error(`Error al remover placa ${plate} de blacklist del parqueo ${parkingId}:`, error);
      throw error;
    }
  },

  // Actualizar spots de un parqueo
  updateSpots: async (parkingId, spots) => {
    try {
      const response = await apiClient.put(`/parkings/${parkingId}/spots`, { spots });
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar spots del parqueo ${parkingId}:`, error);
      throw error;
    }
  },


  // Obtener estadísticas básicas de un parqueo
  getParkingStats: async (parkingId) => {
    try {
      const parking = await parkingService.getParkingById(parkingId);
      
      const stats = {
        totalSpots: parking.spots?.length || 0,
        capacity: parking.capacity,
        blacklistedVehicles: parking.blacklist?.length || 0,
        availableSpots: parking.capacity - (parking.spots?.length || 0)
      };

      return stats;
    } catch (error) {
      console.error(`Error al obtener estadísticas del parqueo ${parkingId}:`, error);
      throw error;
    }
  },

  // Abrir barrera/aguja
  openBarrier: async (parkingId, boomId) => {
    try {
      const response = await apiClient.post('/parkings/barrier/open', { parkingId, boomId }, {
        timeout: 30000, // 30 segundos - la camara puede tardar en responder
      });
      return response.data;
    } catch (error) {
      console.error(`Error al abrir aguja ${boomId}:`, error);
      throw error;
    }
  },

  // Cerrar barrera/aguja
  closeBarrier: async (parkingId, boomId) => {
    try {
      const response = await apiClient.post('/parkings/barrier/close', { parkingId, boomId }, {
        timeout: 30000,
      });
      return response.data;
    } catch (error) {
      console.error(`Error al cerrar aguja ${boomId}:`, error);
      throw error;
    }
  }
};




export default parkingService;
